<template>
    <div>
        <el-dialog 
            title="审批"
            :visible.sync="showDialog"
            width="60%"
            :before-close="closeRepairsDialog"
            append-to-body
            :modal-append-to-body="false"
        >
            <avue-form 
                :option="repairsFormOption"
                v-model="repairsForm"
                @submit="repairsFormSubmit"
                @error="repairsFormError">
                <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入内容"
                                v-model="repairsForm.remark">
                            </el-input>
                            <remarkModel :remark.sync="repairsForm.remark" ref="repairsFormRemarkModel"></remarkModel>
                        </div>
                   
                    </template>
               <template slot="areaId">
                    <el-select
                            v-model="repairsForm.areaId"
                            :value="repairsForm.areaId"
                            placeholder="请选择需求区域"
                            clearable
                            ref="addConnectSelect"
                            >
                            <el-option :value="repairsForm.areaId" show-all-levels :label="repairsForm.areaName">
                                <el-tree
                                    node-key="id"
                                    :data="treeFormAreaData"
                                    :props="treeProps"
                                    :load="editAreaLazyLoadTree"
                                    lazy
                                    @node-click="editAreaNodeTreeClick_"
                                >
                                </el-tree>
                            </el-option>
                    </el-select>
                </template>
                 <template slot="description">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入内容"
                                v-model="repairsForm.description">
                            </el-input>
                            <remarkModel :remark.sync="repairsForm.description" ref="repairsFormRemarkModel"></remarkModel>
                        </div>
                   
                    </template>
                <template slot="requireMainId">
                    <el-select v-model="repairsForm.requireMainId" @change="changeRequireUserHandler_">
                        <el-option
                            v-for="(item,index) in requireUserList"
                            :key="index"
                            :label="item.realName"
                            :value="item.id"
                            ></el-option>
                    </el-select>
                </template>

                <template slot="menuForm">
                    <el-button @click="closeRepairsDialog" ><span class="el-icon-close"></span> 取 消</el-button>
                </template>
                </avue-form>
            
        </el-dialog>
    </div>
</template>
<script>
import {
      getList,
      getprojectList,
      getOrderactionlist,
      getCourseLog,
      getOrderDetail,
      getDictData,
      getGroupName,//获取班组名称以及id
      getMenberUserList,//获取群组下的人员
      lazyAreaTree,//懒加载区域树
      getUserListByDepartmentId,//需求人员
      appoint,//指派
      grabSingle,//抢单
      cancel,//工单取消
      print,//工单打印
      accept,//工单接受
      start,//工单开始
      delay,//工单延迟
      recover,//工单恢复
      finish,//工单完成
      evaluation,//工单评价
      repairs,//工单报修
      scrap,//工单报废
      outsourcing,//工单外委
      getGroupList,//获取班组列表
      complaint,//转办
      getRemarkList,//获取备注模板
    } from "@/api/gateservice/order/order-list/order-list";
    import {getProjectDict} from "@/api/crmedical/project-dictionary/project-dictionary";
    import remarkModel from "../order-list/remark-model"
export default {
    prop:['showDialog'],
    props:{
        showDialog:{
            type:Boolean,
        }
    },
    data(){
        return{
            repairsDialog:false,
            repairsFormOption:{
                    column: [
                        // {
                        //   type: 'select',
                        //   label: '项目名称',
                        //   formslot:true,
                        //   span: 8,
                        //   display: true,
                        //   props: {
                        //     label: 'label',
                        //     value: 'value'
                        //   },
                        //   prop: 'projectId',
                        //   required: true,
                        //   rules: [
                        //     {
                        //       required: true,
                        //       message: '请选择项目名称'
                        //     }
                        //   ]
                        // },
                        {
                        type: 'select',
                        label: '需求区域',
                        formslot:true,
                        span: 12,
                        
                        display: true,
                        prop: 'areaId',
                        rules: [
                            {
                            required: true,
                            message: '请选择需求区域'
                            }
                        ],
                        required: true
                        },
                        {
                        type: 'select',
                        label: '需求人员',
                        formslot:true,
                        span: 12,
                        display: true,
                        props: {
                            label: 'label',
                            value: 'value'
                        },
                        prop: 'requireMainId',
                        rules: [
                            {
                            required: true,
                            message: '请选择需求人员'
                            }
                        ],
                        required: true
                        },
                        {
                        type: 'datetime',
                        label: '期望到场时间',
                        span: 12,
                        display: true,
                        format: 'yyyy-MM-dd HH:mm:ss',
                        valueFormat: 'yyyy-MM-dd HH:mm:ss',
                        prop: 'expectStartTime',
                        required: true,
                        rules: [
                            {
                            required: true,
                            message: '期望到场时间必须填写'
                            }
                        ]
                        },
                        {
                        type: 'select',
                        label: '紧急程度',
                        dicUrl:'/api/blade-system/dict/dictionary?code=order_urgent_level',
                        
                        span: 12,
                        display: true,
                        props: {
                            label: 'dictValue',
                            value: 'dictKey'
                        },
                        prop: 'urgentLevel',
                        required: true,
                        rules: [
                            {
                            required: true,
                            message: '请选择紧急程度'
                            }
                        ]
                        },
                        {
                        type: 'select',
                        label: '业务模块',
                        dicData: [
                            {
                            label: '选项一',
                            value: 0
                            },
                            {
                            label: '选项二',
                            value: 1
                            },
                            {
                            label: '选项三',
                            value: 2
                            }
                        ],
                        cascaderItem: [],
                        span: 12,
                        display: false,
                        props: {
                            label: 'label',
                            value: 'value'
                        },
                        prop: 'moduleJson',
                        rules: []
                        },
                    
                        {
                        type: 'input',
                        label: '经度',
                        span: 12,
                        display: true,
                        prop: 'positionLongitude',
                        required: true,
                        rules: [
                            {
                            required: true,
                            message: '经度必须填写'
                            }
                        ]
                        },
                        {
                        type: 'input',
                        label: '纬度',
                        span: 12,
                        display: true,
                        prop: 'positionLatitude',
                        rules: [
                            {
                            required: true,
                            message: '纬度必须填写'
                            }
                        ],
                        required: true
                        },
                    
                        {
                        type: 'textarea',
                        label: '工单描述',
                        span: 24,
                        display: true,
                        prop: 'description',
                        formslot:true,
                        required: true,
                        rules: [
                            {
                            required: true,
                            message: '工单描述必须填写'
                            },
                            // { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
                        ]
                        }
                    ],
                    labelPosition: 'right',
                    labelSuffix: '：',
                    labelWidth: 120,
                    gutter: 0,
                    menuBtn: true,
                    submitBtn: true,
                    submitText: '提交',
                    emptyBtn: false,
                    emptyText: '清空',
                    menuPosition: 'center',
                    detail: false,
                    tabs: false
                    }
        }
    },
    methods:{
         // 开始弹窗
        openRepairsDialog(index,id){
            getRemarkList({orderId:this.orderId,actionType:index}).then(res=>{
                this.$refs.repairsFormRemarkModel.setRemarkList(res.data);
            })
            this.repairsDialog = true;
          
        },
        // 开始提交
        repairsFormSubmit(form,done){
            form.orderId = this.orderId;
            start(form).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.robOrderDialog = false;
                     this.dialogVisible = false;
                }else{
                    this.$message.error(res.msg);
                }
               
                this.robOrderDialog = false;
                done()
            }).catch(err=>{
                
                
                done()
            })
        },
        // 开始提交报错
        repairsFormError(done){
            done()
        },
        // 关闭开始弹窗
        closeRepairsDialog(done){
            this.repairsForm = {
                
            }
            done()
        },
    }
}
</script>